import { DarkMode } from '@/services/local-storage';

export const state = {
  layoutType: 'horizontal',
  layoutWidth: 'boxed',
  leftSidebarType: 'dark',
  topbar: 'dark',
  loader: false,
  darkMode: DarkMode.get(),
};

export const mutations = {
  CHANGE_LAYOUT(state, layoutType) {
    state.layoutType = layoutType;
  },
  CHANGE_LAYOUT_WIDTH(state, layoutWidth) {
    state.layoutWidth = layoutWidth;
  },
  CHANGE_LEFT_SIDEBAR_TYPE(state, leftSidebarType) {
    state.leftSidebarType = leftSidebarType;
  },
  CHANGE_TOPBAR(state, topbar) {
    state.topbar = topbar;
  },
  LOADER(state, loader) {
    state.loader = loader;
  },

  TOGGLE_DARK_MODE(state) {
    state.darkMode = !state.darkMode;
  },
  TURN_OFF_DARK_MODE() {
    state.darkMode = false;
  },
};

export const actions = {
  changeLayoutType({ commit }, { layoutType }) {
    commit('CHANGE_LAYOUT', layoutType);
  },

  changeLayoutWidth({ commit }, { layoutWidth }) {
    commit('CHANGE_LAYOUT_WIDTH', layoutWidth);
  },

  changeLeftSidebarType({ commit }, { leftSidebarType }) {
    commit('CHANGE_LEFT_SIDEBAR_TYPE', leftSidebarType);
  },

  changeTopbar({ commit }, { topbar }) {
    commit('CHANGE_TOPBAR', topbar);
  },

  changeLoaderValue({ commit }, { loader }) {
    commit('LOADER', loader);
  },

  toggleDarkMode({ commit }) {
    commit('TOGGLE_DARK_MODE');
  },

  turnOffDarkMode({ commit }) {
    commit('TURN_OFF_DARK_MODE');
  },
};
